import React from "react";
import * as Sentry from "@sentry/react";
import { isChunkLoadError } from "utils/chunkReload";

/**
 * Soft-fail boundary for optional lazy UI (surveys, promos, etc.).
 * Never shows the rocket crash screen or triggers a full-page reload —
 * if the chunk or component fails, render nothing and report quietly.
 */
class OptionalLazyBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    const feature = this.props.feature || "optional_lazy";
    console.warn(`[OptionalLazyBoundary:${feature}] failed to load`, error, errorInfo);

    Sentry.captureException(error, {
      tags: {
        optional_lazy: "true",
        optional_lazy_feature: String(feature).slice(0, 64),
        chunk_load_error: isChunkLoadError(error) ? "true" : "false",
      },
      level: "warning",
    });
  }

  render() {
    if (this.state.error) {
      return null;
    }
    return this.props.children;
  }
}

export default OptionalLazyBoundary;
